import { useEffect, useState } from "react";

const DISMISS_KEY = "d20-install-dismissed-at";
const DISMISS_DAYS = 14;
let deferred = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; notify(); });
  window.addEventListener("appinstalled", () => { deferred = null; localStorage.removeItem(DISMISS_KEY); notify(); });
}

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isDismissed = () => Date.now() - Number(localStorage.getItem(DISMISS_KEY) || 0) < DISMISS_DAYS * 86400000;

export const useInstallPrompt = () => {
  const [, bump] = useState(0);
  useEffect(() => { const fn = () => bump((n) => n + 1); listeners.add(fn); return () => listeners.delete(fn); }, []);
  const standalone = isStandalone();
  const ios = isIOS() && !standalone;
  const install = async () => {
    if (!deferred) return "manual";
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") deferred = null;
    notify();
    return outcome;
  };
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); notify(); };
  return { canInstall: !standalone && (!!deferred || ios), native: !!deferred, ios, standalone, dismissed: isDismissed(), install, dismiss };
};
